export default "__VITE_ASSET__dONEw9e3__"